// Loader.js
import React from "react";
import "./Loader.css"; // Make sure to create and import appropriate CSS

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
